import { useState } from 'react';
import { uploadService } from '@/services/upload.service';
import { useToast } from '@/contexts/ToastContext';
import { getErrorMessage } from '@/utils/error';

export const useImageUpload = () => {
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [uploadingBackground, setUploadingBackground] = useState(false);
  const [uploadingImage1, setUploadingImage1] = useState(false);
  const [uploadingImage2, setUploadingImage2] = useState(false);
  const [uploadingSpeakerPhoto, setUploadingSpeakerPhoto] = useState(false);
  const { addToast } = useToast();

  const uploadImage = async (
    file: File,
    type: 'logo' | 'photo' | 'background' | 'image1' | 'image2' | 'speakerPhoto'
  ): Promise<{ s3Key: string; signedUrl: string } | null> => {
    const setters = {
      logo: setUploadingLogo,
      photo: setUploadingPhoto,
      background: setUploadingBackground,
      image1: setUploadingImage1,
      image2: setUploadingImage2,
      speakerPhoto: setUploadingSpeakerPhoto,
    };

    const labels = {
      logo: 'Logo',
      photo: 'Photo',
      background: 'Background image',
      image1: 'Image 1',
      image2: 'Image 2',
      speakerPhoto: 'Speaker photo',
    };

    const setter = setters[type];
    const label = labels[type];

    setter(true);
    try {
      const validation = uploadService.validateFile(file, 'image', 5);
      if (!validation.valid) {
        addToast(validation.error || 'Invalid file', 'error');
        return null;
      }

      const response = await uploadService.uploadImage(file);
      addToast(`${label} uploaded successfully`, 'success');
      // Return both S3 key (for saving) and signedUrl (for immediate display)
      // Store S3 key in postData, use signedUrl for display only
      return {
        s3Key: response.url || '', // S3 key (permanent identifier) - stored in postData
        signedUrl: response.url || '', // Use response.url for immediate display
      };
    } catch (error: unknown) {
      console.error(`Failed to upload ${type}:`, error);
      addToast(getErrorMessage(error), 'error');
      return null;
    } finally {
      setter(false);
    }
  };

  return {
    uploadImage,
    uploadingLogo,
    uploadingPhoto,
    uploadingBackground,
    uploadingImage1,
    uploadingImage2,
    uploadingSpeakerPhoto,
  };
};

